import React, { useState } from "react";
import DropdownComp from "../../../dropdown/dropdown";
import ADOPopup from "../ADOPopup";
import { useTranslation } from 'react-i18next';

const MetricInstanceSelection = props => {
  const [showPopup, setShowPopup] = useState(false);
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="jira-dropdown-container">
        <DropdownComp
          options={props.instances} // Replace with props later, might need to make a new object with values and names
          defaultValue={props.selectedInstance.value}
          onChange={props.handleChange} // Should make another api call to fetch all the other projects
          wrapperClass="add-okrs-dropdown-wrapper popup-dropdown-wrapper"
          selectClass="border-box"
          hideSelectedOption={true}
          appendId="metric-instance-duration"
        />
        {props.authType === "personal_token" && (
          <div
            onClick={() => setShowPopup(true)}
            className="add-new-instance"
          >
            + {t('Connect to new instance')}
          </div>
        )}
      </div>
      {props.selectedInstance.token_state === "invalid" && (
        <div className="amber-text warning-error">
          <i className="icon icon-warning_14px_amber" />
          {`${t('The organization associated with this key result')} \
          ${t('has been disabled and/or the token has been revoked.')}`}
        </div>
      )}
      {showPopup && (
        <ADOPopup
          closePopup={() => setShowPopup(false)}
          updateParentState={props.updateInstances}
        />
      )}
    </>
  );
};

export default MetricInstanceSelection;
